<script>
  import ToolTip from "@/components/atoms/ToolTip.vue";
  import IconWithTooltip from "../../../components/molecules/iconWithTooltip.vue";

  export default {
    data() {
      return {
        hoveredCredId: null,
        showLastActivity: false,
      };
    },
    props: ["user"],
    components: { ToolTip, IconWithTooltip },
    computed: {
      state() {
        const { isActive, isOnline } = this.user;
        return isActive && isOnline ? "online" : !isActive && isOnline ? "away" : "offline";
      },
      roleUser() {
        const role = this.getRoleFromEntry(this.user.rolesApp?.autologin);
        const roleInver = this.$global.dictionary.rolesInver[role];
        return this.$global.dictionary.roles_es_auto[roleInver];
      },
      platforms() {
        return this.user?.credentials?.filter((item) => item.password);
      },
      loggedUser() {
        return this.$store.getters["user/getProfile"];
      },
      hasLicenceReason() {
        return ["licencia", "vacaciones", "incapacidad"].includes(this.user.reasonDisable);
      },
    },
    methods: {
      getRoleFromEntry(entry) {
        if (!entry) return "";
        if (Array.isArray(entry)) return entry[0] || "";
        if (typeof entry === "string") return entry;
        return entry?.role || entry?.[0] || "";
      },
      hasRoom(user) {
        return user.room && user.room !== "null";
      },
      onEnter(id) {
        this.hoveredCredId = id;
      },
      onLeave() {
        this.hoveredCredId = null;
      },
    },
  };
</script>

<template>
  <section class="usersCard">
    <router-link class="usersCard__wrapper" :to="{ name: 'generalInfo', params: { id: user._id }, query: $route.query }">
      <div class="usersCard__sectionDataContent">
        <div class="usersCard__section usersCard__section--left">
          <div class="usersCard__avatarContainer" :stateAvatar="state">
            <Avatar class="usersCard__avatar" :user="user" />
            <span class="usersCard__statusCircle" :stateAvatar="state"></span>
          </div>
        </div>

        <div class="usersCard__sectionDataContentDetails">
          <div class="usersCard__sectionData">
            <p class="usersCard__userName">{{ user.artisticName || user.user }}</p>
            <div class="usersCard__location">
              <p class="usersCard__dataLocation">
                {{ user.city }} <span class="usersCard__dataLocation" v-if="user.office && user.office !== 'null'"> - {{ user.office }}</span>
              </p>
              <span class="usersCard__pipe" v-if="hasRoom(user)">|</span>
              <span class="usersCard__dataLocation" v-if="hasRoom(user)">{{ user.room }}</span>
            </div>
            <div class="usersCard__platforms" v-if="user.role === 'model'">
              <div class="usersCard__contentLogos" v-for="cred in platforms" :key="cred._id" @mouseenter="onEnter(cred.platformId._id)" @mouseleave="onLeave">
                <IconWithTooltip :showToolTip="hoveredCredId === cred.platformId._id" :text="cred.platformId.name" :img="cred.platformId.logo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="usersCard__content">
        <div class="usersCard__infoData">
          <iconic class="usersCard__flag" name="flag" v-if="user.redFlag" />
          <div class="usersCard__contentIcon" @mouseenter="showLastActivity = true" @mouseleave="showLastActivity = false">
            <ToolTip v-if="showLastActivity" variant="down" text="Ultima actividad" />
            <iconic class="usersCard__time" name="time" />
            <span class="usersCard__text">{{ user.lastActivity ? $global.getElapsedTime(new Date(user.lastActivity)) : "Sin actividad" }}</span>
          </div>
        </div>
        <p class="usersCard__role" v-if="loggedUser.role !== 'monitor'">
          <iconic class="usersCard__user" name="newUserIcon" />
          <span class="usersCard__text">{{ roleUser }}</span>
        </p>
        <div class="usersCard__licenceTag" v-if="hasLicenceReason && loggedUser.role === 'monitor'">Licencia</div>
      </div>
    </router-link>
  </section>
</template>

<style lang="scss">
  .usersCard {
    width: 100%;
    border-radius: 6px;
    a {
      text-decoration: none;
      color: black;
      border-radius: 8px;
      background: #f9f9f9;
    }

    &__licenceTag {
      padding: 2px 10px;
      border-radius: 21px;
      font-size: 11px;
      color: #c77700;
      font-family: $newFont_regular;
      border: 1px solid #c77700;
      background: #fffef5;
    }

    &__wrapper {
      @include Flex(column, flex-start, flex-start);
      flex-wrap: nowrap;
      width: 100%;
      height: 99px;
      padding: 10px 20px;
      gap: 7px;
      user-select: none;
      border-radius: 6px;
      transition: 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        background: #ededed;
      }
    }

    &__section {
      width: 40px;
      height: 40px;
      &--right {
        @include Flex(column);
        width: 50px;
      }
    }
    &__sectionDataContent {
      @include Flex(row);
      gap: 16px;
      width: calc(100%);
    }
    &__sectionDataContentDetails {
      display: flex;
      width: 100%;
      gap: 15px;
    }

    &__sectionData {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
      width: 100%;
      max-width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &__location {
      @include Flex(row, flex-start);
      grid-column: 1;
      grid-row: 2;
      gap: 10px;
    }

    &__role {
      @include Flex(row);
      gap: $space-8;
      width: fit-content;
    }

    &__contentLogos {
      position: relative;
    }

    &__pipe {
      color: #595959;
      font-style: 5px;
    }

    &__sectionDataContainer {
      @include Flex(column, flex-start, flex-start);
      gap: 4px;
    }
    &__infoData {
      @include Flex(row, flex-start);
      gap: 23px;
      font-size: 15px;
      padding-left: 11px;
    }

    &__user {
      font-size: 18px;
      color: $darkGray;
    }

    &__content {
      @include Flex(row, space-between);
      width: 100%;
    }
    &__avatarContainer {
      position: relative;
      width: 40px;
      height: 40px;
      border: 2px solid $alto;
      border-radius: 50%;
      &[stateAvatar="online"] {
        border-color: $la_palma;
      }
      &[stateAvatar="away"] {
        border-color: $tree_Poppy;
      }
    }

    &__avatar {
      width: 100%;
      height: 100%;
      font-size: 15px;
      border: 2px solid $white;
    }
    &__time {
      font-size: 18px;
      color: $darkGray;
    }
    &__statusCircle {
      position: absolute;
      width: 10px;
      height: 10px;
      right: 2px;
      bottom: 2px;
      border: 2px solid $white;
      border-radius: 50%;
      background-color: $alto;
      &[stateAvatar="online"] {
        background-color: $la_palma;
      }
      &[stateAvatar="away"] {
        background-color: $tree_Poppy;
      }
    }
    &__userName {
      font-family: $newFont_medium;
      color: #212121;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    &__text {
      text-overflow: ellipsis;
      text-transform: capitalize;
      font-family: $newFont_regular;
      color: $darkGray;
    }
    &__contentIcon {
      @include Flex(row);
      gap: 7px;
      position: relative;
    }
    &__dataLocation {
      border-radius: 15px;
      color: #3d3d3d;
      font-weight: 500;
      font-size: 14px;
      font-family: $newFont_regular;
    }
    &__flag {
      color: $primary-color;
      font-size: 20px;
    }
    &__platforms {
      @include Flex(row, flex-end);
      width: 100%;
      grid-column: 2;
      grid-row: 1;
      gap: 14px;
    }

    &__logo {
      @include Flex(row);
      width: 22px;
      height: 22px;
      border-radius: 4px;
      &--streamate {
        background: #21619a;
        color: white;
      }
      &--jasmin {
        background-color: $primary-color;
        color: white;
      }
    }
    .globalAvatar span {
      font-family: $newFont_medium;
    }
    .tooltipContainer--down {
      top: -33.36px;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.7);
      box-shadow: 0px 1.13px 3px 0px rgba(0, 0, 0, 0.28);
      backdrop-filter: blur(2.82608699798584px);
    }
  }
</style>
